import React from 'react';
import { Month } from '../atoms/Month';
import { useCalendar } from '../hooks/useCalendar';

interface MonthGridProps {
  currentDate: Date;
  selectedMonth?: number;
  onMonthSelect: (monthIndex: number) => void;
  monthNames?: string[];
  className?: string;
}

export const MonthGrid: React.FC<MonthGridProps> = ({
  currentDate,
  selectedMonth,
  onMonthSelect,
  monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  className = '',
}) => {
  const { getMonthNames } = useCalendar(
    currentDate,
    () => {},
    () => {}
  );

  const months = getMonthNames();

  return (
    <div className={`ui-mx-auto ui-grid ui-w-fit ui-grid-cols-3 ${className}`}>
      {months.map((monthName, index) => (
        <Month
          key={index}
          monthIndex={index}
          monthName={monthName}
          isSelected={selectedMonth === index}
          isDisabled={false}
          onClick={onMonthSelect}
        />
      ))}
    </div>
  );
};
